// create a new instance of DOMParser
export const domParser =  new DOMParser();
